import { render, staticRenderFns } from "./chitolawitem.vue?vue&type=template&id=008420cc&scoped=true&"
import script from "./chitolawitem.vue?vue&type=script&lang=js&"
export * from "./chitolawitem.vue?vue&type=script&lang=js&"
import style0 from "./chitolawitem.vue?vue&type=style&index=0&id=008420cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008420cc",
  null
  
)

export default component.exports